import {Action} from "../../../action/action";
import type DetailsState from "..";
import { Booking } from "@raskrask-dk/raskrask-utils";


export const SET_PROMO_CODE = "SET_PROMO_CODE";

export class SetPromoCode extends Action<typeof SET_PROMO_CODE, string> {
  readonly type = SET_PROMO_CODE;

  protected state: DetailsState;

  constructor(state: DetailsState, promoCode?: string | undefined) {
    super(state, promoCode);
    this.state = state;
  }
  /**
   * Business Logic:
   * If the Product is of type package - this action shouldn't be available.
   * IF product is of type Ondemand this action is unavailable
   * @returns
   */
  public isDoable(): boolean {
    const {product, customerType} = this.state;
    const isProductABooking = product instanceof Booking;
    const isPrivateCustomer = customerType === "Private";
    return isProductABooking && isPrivateCustomer;
  }
  public isValid(): boolean {
    return this.isDoable();
  }
}
